module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask modal-lg"
  }, [_c('div', {
    staticClass: "modal-wrapper box"
  }, [(_vm.showColumnPicker) ? _c('columns-picker-modal', {
    attrs: {
      "available-columns": _vm.availableColumns
    },
    on: {
      "close": function($event) {
        _vm.showColumnPicker = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "fa fa-2x fa-columns pull-left",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showColumnPicker = !_vm.showColumnPicker
      }
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.componentModel.name))])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_c('div', {
    staticClass: "row",
    style: ({
      height: _vm.tableHeight + 'px'
    })
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col-xs-12 chart-wrapper"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 chart-wrapper"
  }, [_c('div', {
    staticClass: "endless-table-container"
  }, [_c('endless-table', {
    attrs: {
      "storage-key": _vm.componentModel.id + '-leads-q',
      "picked-columns": _vm.pickedColumns,
      "field-list": _vm.query.fields,
      "order-by": _vm.query.order_by,
      "order-asc": _vm.query.asc,
      "lead-list": _vm.leads
    },
    on: {
      "fetchLeads": _vm.fetchLeads
    }
  })], 1)])])])], 2)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8c34b3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/LeadsModal.vue
// module id = 667
// module chunks = 0